$(function () {
  // このスクリプトは taxonomy-case_category ページのみで動作させる
  if ($("body").hasClass("tax-case_category")) {
    // タイトル（フィルター名表示用）の <b> 要素を取得
    const titleElement = document.querySelector(".p-FilterTitle__text span b");

    /**
     * フィルターの選択によって、リンク先や表示文言を変更する処理
     * - 特定の子カテゴリが選ばれたら、ACFで設定した trend_url に変更
     * - 選ばれていなければ元のリンクに戻す
     */
    function updateFilter() {
      const selectedRadio = document.querySelector('input[name="filter"]:checked');
      if (!selectedRadio) return;

      const selectedValue = selectedRadio.value; // 選択されたラジオボタンの value（カテゴリslug）
      const label = selectedRadio.closest("label"); // ラジオの親ラベル
      const labelText = label ? label.textContent.trim() : "すべて";

      // リンク出力エリア（PCとSP）
      const filterBtnPC = document.querySelector(".p-FilterTitle__btn.u-pc");
      const filterBtnSP = document.querySelector(".p-FilterTitle__btn.u-sp");

      // 現在表示中の親カテゴリのスラッグを取得（PHPから渡された変数）
      const currentParentSlug = window.currentCaseCategorySlug;

      // 親カテゴリに紐づくリンクマップを取得（PHP側で生成したオブジェクト）
      const linkMap = window.caseSpecialLinks?.[currentParentSlug];

      // 子カテゴリの中に特別リンクが定義されている場合のみ、リンクを上書き
      if (linkMap && linkMap[selectedValue]) {
        const { url, text } = linkMap[selectedValue];

        // PCリンクに反映
        if (filterBtnPC) {
          const a = filterBtnPC.querySelector("a");
          if (a) {
            a.href = url;
            a.textContent = text;
          }
        }

        // SPリンクに反映
        if (filterBtnSP) {
          const a = filterBtnSP.querySelector("a");
          if (a) {
            a.href = url;
            a.textContent = text;
          }
        }
      } else {
        // 特別リンクがなければ、元の（初期状態の）リンクに戻す
        if (filterBtnPC) {
          const a = filterBtnPC.querySelector("a");
          if (a && a.dataset.defaultHref && a.dataset.defaultText) {
            a.href = a.dataset.defaultHref;
            a.textContent = a.dataset.defaultText;
          }
        }

        if (filterBtnSP) {
          const a = filterBtnSP.querySelector("a");
          if (a && a.dataset.defaultHref && a.dataset.defaultText) {
            a.href = a.dataset.defaultHref;
            a.textContent = a.dataset.defaultText;
          }
        }
      }

      // タイトル部分の表示も選択中のフィルターに合わせて変更
      if (titleElement) {
        titleElement.textContent = labelText;
      }
    }

    /**
     * 初期化関数：ページ表示時とフィルター変更時に updateFilter を実行
     */
    function initialize() {
      // ページ読み込み直後に現在の選択状態を反映
      setTimeout(updateFilter, 10);

      // 各ラジオボタンに変更イベントを追加
      const radios = document.querySelectorAll('input[name="filter"]');
      radios.forEach((radio) => {
        radio.addEventListener("change", updateFilter);
      });
    }

    // 初期化実行
    initialize();
  }
});
